<template>
  <div class="topLogo">
    <div class="rengaLogo">
      <div class="rengaLogo__text">
        <img src="@/assets/top/renga-logo-text.png" alt="" />
      </div>
      <div class="rengaLogo__logo">
        <img src="@/assets/top/renga-logo.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopLogo"
};
</script>

<style scoped lang="sass">
@import "../../../sass/common"
.topLogo
    position: relative
    height: 365px
    //margin-bottom: 160px
    text-align: center
.piaLogo
    position: absolute
    top: 1px
    width: 100%
    img
        margin-left: -4px
        width: 94px
.rengaLogo__text
    position: absolute
    width: 100%
    top: 17.5px
    img
        margin-left: -16px
        @include perW2(433)
.rengaLogo__logo
    position: absolute
    width: 100%
    top: 42px
    img
      @include perW2(712)
</style>
